module.exports = __webpack_public_path__ + "img/login.d7e42f69.png";